import { connect } from "react-redux";
import ChannelsComponent from "../../Components/Queues/ChannelsComponent";
const mapStateToProps = (state) => ({
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    chatFlows:state.reducer.chatFlows,
});
const mapDispatchToProps = (dispatch) => ({
   
});
 
export default connect(mapStateToProps, mapDispatchToProps)(ChannelsComponent);